import {InputFieldType} from '@/model/types';

export const DEFAULT_MASKS: Partial<Record<InputFieldType, string>> = {
  date: 'yyyy-mm-dd',
  tel: '### ###-####',
};

export const getDefaultMaskByFieldType = (type: InputFieldType | string): string | undefined => {
  if (type in DEFAULT_MASKS) {
    return DEFAULT_MASKS[type as InputFieldType];
  }

  return undefined;
};
